const reminderDuration = 5 * 60 * 1000;
const reminderStorageKey = 'gloweytree-cart-reminder-deadline';
let reminderDeadline;

function getReminderDeadline() {
  if (reminderDeadline) return reminderDeadline;

  try {
    const savedDeadline = Number(sessionStorage.getItem(reminderStorageKey));
    if (Number.isFinite(savedDeadline) && savedDeadline > 0) {
      reminderDeadline = savedDeadline;
      return reminderDeadline;
    }
  } catch {
    // Keep the reminder usable when storage is disabled.
  }

  reminderDeadline = Date.now() + reminderDuration;
  try {
    sessionStorage.setItem(reminderStorageKey, String(reminderDeadline));
  } catch {
    // Keep the deadline in memory for this page.
  }
  return reminderDeadline;
}

class GloweyTreeCartReminder extends HTMLElement {
  connectedCallback() {
    this.hidden = false;
    this.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      this.observer.disconnect();
      const deadline = getReminderDeadline();
      const update = () => {
        const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        const time = this.querySelector('[data-gt-time]');
        const expired = this.querySelector('[data-gt-expired]');
        if (!time || !expired) return;
        time.hidden = remaining === 0;
        expired.hidden = remaining > 0;
        if (remaining === 0) {
          clearInterval(this.interval);
          return;
        }
        const minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
        const seconds = String(remaining % 60).padStart(2, '0');
        time.textContent = minutes + ':' + seconds;
      };
      this.interval = setInterval(update, 250);
      update();
    });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    clearInterval(this.interval);
  }
}

if (!customElements.get('gt-cart-reminder')) {
  customElements.define('gt-cart-reminder', GloweyTreeCartReminder);
}
